module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/report-items/client-scale-results/client-scale-results.component.scss
// module id = ./src/app/reports/report-items/client-scale-results/client-scale-results.component.scss
// module chunks = main